export const womenClothings = [ 
    {
    id: 0,
    name: 'Crew neck tshirt',
    price: 29.99,
    image: './asset/crew-neck-female-tshirt-01.png'
    },
    {
        id: 1,
        name: 'Crop top',
        price: 29.99,
        image: './asset/crop-top-female-01.png'
    },
    {
        id: 2,
        name: 'Wide neck',
        price: 19.99,
        image: './asset/wide-neck-female-tshirt-01.png'
    },
    {
        id: 3,
        name: 'Black dress',
        price: 39.99,
        image: './asset/dress-female.png'
    },
    {
        id: 4,
        name: 'Hoodie white',
        price: 39.99,
        image: './asset/hoodie-female-01.png'
    },
    {
        id: 5,
        name: 'Hoodie grey',
        price: 39.99,
        image: './asset/hoodie-female-02.png'
    },
    {
        id: 6,
        name: 'Lsleeve tshirt',
        price: 29.99,
        image: './asset/long-sleeve-female-tshirt-01.png'
    },
    {
        id: 7,
        name: 'Lsleeve tshirt2',
        price: 29.99,
        image: './asset/long-sleeve-female-tshirt-02.png'
    },
    {
        id: 8,
        name: 'Wide neck 2',
        price: 29.99,
        image: './asset/wide-neck-female-tshirt-02.png'
    },
    {
        id: 9,
        name: 'Lsleeve tshirt3',
        price: 29.99,
        image: './asset/long-sleeve-female-tshirt-04.png'
    },
    {
        id: 10,
        name: 'Lsleeve tshirt4',
        price: 29.99,
        image: './asset/long-sleeve-female-tshirt-04.png'
    },
    {
        id: 11,
        name: 'Polo white',
        price: 39.99,
        image: './asset/polo-female.png'
    },
    {
        id: 12,
        name: 'Tank top',
        price: 29.99,
        image: './asset/tank-top-female-01.png'
    },
    {
        id: 13,
        name: 'Crop top 2',
        price: 29.99,
        image: './asset/crop-top-female-02.png'
    },

]